// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".flex-content[data-v-2e33ed8c]{display:flex;flex-direction:column;flex-grow:1}", ""]);
// Exports
module.exports = exports;
